import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGenderFemale = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 11 20" {...props}>
    <g
      transform="translate(0 1)"
      stroke="#E568B2"
      fill="none"
      fillRule="evenodd"
    >
      <path d="M1.198 12.083 3.95 6.614a1 1 0 0 1 .894-.55h1.28a1 1 0 0 1 .89.545l2.803 5.483a1 1 0 0 1-.89 1.455H8.14a1 1 0 0 0-1 1v2.77a1 1 0 0 1-1 1H4.972a1 1 0 0 1-1-1v-2.793a1 1 0 0 0-1.009-1l-.863.008a1 1 0 0 1-.902-1.45Z" />
      <circle cx={5.614} cy={2.159} r={2.159} />
    </g>
  </svg>
);
const Memo = memo(SvgGenderFemale);
export default Memo;
